import React from 'react';
import PropTypes from 'prop-types';
import SVGInline from "react-svg-inline"

// inner imports
import { getRandomInRange } from '../../../utils';

// Style import
import './RandomIcons.css';

const RandomIcons = ({
                        iconSVG = '',
                        customClass = '',
                        numIcons = 5,
                        topLimit,
                        bottomLimit,
                        leftLimit,
                        rightLimit,
                        isSmall,
                        opacity,
                        isLoopMove
}) => {
    const randomize = (min, max) => {
        return getRandomInRange(min, max);
    };

    const generateIcons = () => {
        const icons = [];
        for (let i = 0; i < numIcons; i++) {
            icons.push(
                <SVGInline
                    key={`random-icon-${i}}`}
                    className={`random-icon ${isSmall ? 'small' : ''} ${isLoopMove ? 'idle-move' : ''}`}
                    svg={iconSVG}
                    component={'i'}
                    style={{
                        top: randomize(bottomLimit || 0, topLimit || 400),
                        left: randomize(leftLimit || -100, rightLimit || window.innerWidth),
                        opacity: opacity || 0.6
                    }}
                />
            )
        }

        return icons;
    };

    return (
        <div className={`random-icons-wrapper ${customClass}`}>
            {generateIcons()}
        </div>
    )
};

RandomIcons.propTypes = {
    customClass: PropTypes.string,
    opacity: PropTypes.number,
    topLimit: PropTypes.number,
    bottomLimit: PropTypes.number,
    leftLimit: PropTypes.number,
    rightLimit: PropTypes.number,
    iconSVG: PropTypes.string,
    numIcons: PropTypes.number,
    isSmall: PropTypes.bool,
    isLoopMove: PropTypes.bool
};

export default RandomIcons;




// WEBPACK FOOTER //
// ./src/Components/Elements/Decorations/RandomIcons.js